import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField, Box, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import PasswordValidationRules from './PasswordValidationRules';

/**
 * Composant de champ de mot de passe réutilisable avec règles de validation
 */
function PasswordField({
  field,
  error,
  helperText,
  label,
  showRules = true,
  onChange,
  ...params
}) {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleChange = (e) => {
    setPassword(e.target.value);
    // Appeler le onChange du field de react-hook-form
    field.onChange(e);
    // Appeler le onChange personnalisé si fourni
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <Box>
      <TextField
        {...field}
        {...params}
        fullWidth
        label={label || t('Password')}
        type={showPassword ? 'text' : 'password'}
        autoComplete="new-password"
        variant="standard"
        error={error}
        helperText={helperText}
        onChange={handleChange}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={t('Toggle password visibility')}
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      {showRules && password && <PasswordValidationRules password={password} />}
    </Box>
  );
}

export default PasswordField; 